function soAlfaNumerico(v) {
    if (v != undefined) {
        v = v.replace(/[^a-zA-Z0-9]/g, "");
    }
    return v;
}
